
import UmImage from './src/main'

UmImage.install = function(Vue) {
  Vue.component(UmImage.name, UmImage)
}

export default UmImage
